import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.css';
import { CarAllocation } from '../../../../../types/carAllocation';
import AllocatedTask from '../../AllocatedTask';
import { getWorkCategoryIDByName } from '../../../../../services/workCategory';

type Props = {
  allocations: CarAllocation[];
  onRequestClose?: () => void;
};

function AllocationDetails({ allocations, onRequestClose }: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.buttons}>
        <CloseButton onClick={onRequestClose} />
      </div>
      {allocations.map((allocation) => (
        <AllocatedTask
          key={allocation.carAllocationId}
          allocation={allocation}
          compact
          minimum={[
            getWorkCategoryIDByName('出発'),
            getWorkCategoryIDByName('到着'),
          ].includes(allocation.workCategory.id)}
          shortened={
            allocation.workCategory.id === getWorkCategoryIDByName('積込') ||
            (allocation.workCategory.id === getWorkCategoryIDByName('処分') &&
              !allocation.goesStraight)
          }
        />
      ))}
    </div>
  );
}

export default AllocationDetails;

function CloseButton({ onClick }: { onClick?: () => void }) {
  return (
    <button type="button" className={styles.closeButton} onClick={onClick}>
      <FontAwesomeIcon icon={faXmark} />
    </button>
  );
}
